import parse from 'url-parse'
import config from '../config'

let redirectToSignUp = () => {}

if (typeof window !== 'undefined') {
  const stateObj = {
    path: '/',
    search: window.location.search
  }
  const OAUTH__LOGIN_URL = config.oauthBaseUrl + '/connect/authorize'
  const APP_BASE_URL = config.dashboardBaseUrl
  const CLIENT_ID = config.clientId // Official Rebrandly Dashboard Client ID
  const RBGY_CLIENT_ID_SKIP_VERIFICATION = config.RbgyFreeTrialClientId // RB.GY Client ID for start free trial with no verification

  let encodeState = (obj = stateObj) => {
    return btoa(JSON.stringify(obj))
  }

  let oauthLoginObject = {
    client_id: CLIENT_ID,
    redirect_uri: APP_BASE_URL,
    state: encodeState(),
    response_type: 'token',
    scope: 'rbapi offline_access'
  }

  let oauthSignUpObject = {
    ...oauthLoginObject,
    acr_values: 'register cmd:direct'
  }

  let oauthSignUpObjectNoVerification = {
    ...oauthSignUpObject,
    client_id: RBGY_CLIENT_ID_SKIP_VERIFICATION,
    response_type: 'token',
    scope: 'accounting carts'
  }

  let buildUrlRedirectToOauth = (params = oauthLoginObject) => {
    const url = parse(OAUTH__LOGIN_URL)
    url.set('query', params)
    return url.href
  }

  /**
    This method redirects the user to the signup page with the necessary parameters. It supports the start free trial and free account creation.
    Buy now is not supported for now.
   */
  redirectToSignUp = (config = {}) => {
    const s = config.search || window.location.search
    let state = {
      path: config.path || '/setup',
      search: s ? s + '&p=firstlogin' : '?p=firstlogin',
      ...(config.isTrialSkipVerification ? {client_id: RBGY_CLIENT_ID_SKIP_VERIFICATION} : {}) // RB.GY Client ID for start free trial with no verification
    }
    if (config.links) {
      state.links = config.links
    }

    state = encodeState(state)

    const flow = 'user'

    let acrValues = oauthSignUpObject.acr_values + ' flow:' + flow

    if (config.plan) {
      acrValues = acrValues + ' plan:' + config.plan
    }
    if (config.provider) {
      acrValues = acrValues + ' cmd:provider-' + config.provider
    }

    // These query param is what makes the .NET OAuth proj to change the Left Side of the HTML and to fill it with the planName (for free trial)
    if(config.isTrialSkipVerification) {
      if (config.category) {
        acrValues += ' category:' + config.category
      }
      if (config.planName) {
        acrValues += ' planname:' + config.planName
      }
    }

    const params = {
      ...(config.isTrialSkipVerification ? oauthSignUpObjectNoVerification : oauthSignUpObject),
      acr_values: acrValues,
      state
    }

    return buildUrlRedirectToOauth(params)
  }
}

export {
  redirectToSignUp
}
